module.exports = __webpack_public_path__ + "static/surveillance-490ac6cea01f1e95e0117bdf7c9ab604.jpg";